module.exports = __webpack_public_path__ + "static/media/41.7b64beeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/41.jpg
// module id = 301
// module chunks = 0